import { useOrganizationStore } from '../stores/useOrganizationStore';
import { orgShowsCrmStage } from '../utils/crmStageDisplay';

/** True when the current org's active CRM connection has stage sync on (FUB, CINC). */
export function useShowCrmStage(): boolean {
  return useOrganizationStore((s) => orgShowsCrmStage(s.organization?.crmConnections));
}
